import { render, staticRenderFns } from "./reckon.vue?vue&type=template&id=5e5184cb&scoped=true"
import script from "./reckon.vue?vue&type=script&lang=js"
export * from "./reckon.vue?vue&type=script&lang=js"
import style0 from "./reckon.vue?vue&type=style&index=0&id=5e5184cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5184cb",
  null
  
)

export default component.exports